'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Fulfill all ViasPromise in the props
function _fulfillPromises(props, promiseCache) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var promiseCb = arguments[3];
  var cb = arguments[4];

  var promises = (0, _util.filterViasPromises)(props);
  var toAdd = Object.assign({}, promises);
  var count = Object.keys(promises).length;
  var toFulfill = [];
  // Put promise in order so that promises with dependencies will be fulfilled after their dependencies
  while (toFulfill.length < count) {
    for (var _iterator = Object.entries(toAdd), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var _ref2 = _ref,
          key = _ref2[0],
          promise = _ref2[1];

      if (promise.dependencies) {
        var dependenciesAdded = true;
        for (var _iterator2 = Object.entries(promise.dependencies), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref3 = _iterator2[_i2++];
          } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref3 = _i2.value;
          }

          var _ref4 = _ref3,
              dependencyKey = _ref4[0],
              dependency = _ref4[1];

          if (!promises[dependencyKey]) {
            throw 'Depency ' + dependencyKey + ' of ' + key + ' is not in props';
          }
          if (!dependency.key) {
            dependenciesAdded = false;
            break;
          }
        }
        if (!dependenciesAdded) {
          continue;
        }
      }
      promise.setKey(key).setPromiseCache(promiseCache);
      toFulfill.push(promise);
      delete toAdd[key];
    }
  }

  (0, _util.asyncEachOf)(toFulfill, function (promise, index, eCb) {
    promise.fulfill(options).onFinish(function (err) {
      if (promiseCb) {
        promiseCb(err, promise);
      }
      eCb(err);
    });
  }, function (err) {
    (0, _util._setImmediate)(function () {
      return cb && cb(err);
    });
  });
}

// Check if server component is rendered in server side
var server = typeof window === 'undefined';

// Flag to indicate if the first component has mounted
var first = true;

function vias() {
  return function (WrappedComponent) {
    var Vias = function (_React$Component) {
      _inherits(Vias, _React$Component);

      // Class method for fulfilling promises on the server
      Vias.fulfillAll = function fulfillAll(props, cb) {
        // allow component to consume data synchronously
        _fulfillPromises(props, {}, {}, null, cb);
      };

      function Vias(props) {
        _classCallCheck(this, Vias);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.models = {};
        // Promise cache to prevent promise with same data fulfill twice
        _this.promises = {};
        // Try to consume the data synchronously
        // for server side rendered component
        // and the first vias component on client side
        if (first || server) {
          _fulfillPromises(props, _this.promises, { sync: true });
        }
        return _this;
      }

      // subscribeModel(model) {
      //   if (!this.models[model.name]) {
      //     this.models[model.name] = {
      //       model: model,
      //       listener: () => {
      //         this.forceUpdate();
      //       },
      //     };
      //   }
      // }

      Vias.prototype.fulfillPromises = function fulfillPromises(props) {
        var _this2 = this;

        _fulfillPromises(props, this.promises, {}, function () {
          _this2.forceUpdate();
        });
      };

      Vias.prototype.componentWillMount = function componentWillMount() {
        if (!server) {
          this.fulfillPromises(this.props);
        }
        (0, _util._setImmediate)(function () {
          first = false;
        });
      };

      Vias.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.fulfillPromises(nextProps);
      };

      Vias.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      // componentWillUnmount() {
      //   for (let name in this.models) {
      //     if (this.models.hasOwnProperty(name)) {
      //       let {model, listener} = this.models[name];
      //       model.unsubscribe(listener);
      //     }
      //   }
      // }


      return Vias;
    }(_react2.default.Component);

    return (0, _hoistNonReactStatics2.default)(Vias, WrappedComponent);
  };
}

exports.default = vias;


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/Vias.js
// module id = 572
// module chunks = 15